var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onFormSubmit.apply(null, arguments)}}},[_vm._t("default",null,{"onChange":_vm.onChange,"resetForm":_vm.resetForm,"formRef":_vm.formRefIdentifier})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }